<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane label="待审核" name="first">
        <keep-alive>
        <ChildAuditTable v-if="activeName=='first'" :status="1"></ChildAuditTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="待定" name="second">
        <keep-alive>
        <ChildAuditTable v-if="activeName=='second'" :status="5"></ChildAuditTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="退回" name="third">
        <keep-alive>
        <ChildAuditTable v-if="activeName=='third'" :status="4"></ChildAuditTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="拒绝" name="fourth">
        <keep-alive>
        <ChildAuditTable v-if="activeName=='fourth'" :status="3"></ChildAuditTable>
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="全部申请" name="fiveth">
        <keep-alive>
        <ChildAuditTable v-if="activeName=='fiveth'" :active="activeName" status="1,2,3,4,5"></ChildAuditTable>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import ChildAuditTable from './ChildAuditTable'
  export default {
    components: {
      ChildAuditTable
    },
    data() {
      return {
        activeName: "first"
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/child/audit/ChildAuditPage.vue